export enum Access {
  NoAccess = 1,
  Read = 2,
  ReadWrite = 3
}

export enum Function {
  AddStudy = 1,
  EditStudy = 2,
  DeleteStudy = 3,
  ExportStudy = 4,
  PublishStudy = 5,
  PreviewStudy = 6,
  EnterApplicant = 7,
  AddQuestion = 8,
  EditQuestion = 9,
  DeleteQuestion = 10,
  EditApplicant = 11,
  DeleteApplicant = 12,
  ExportApplicant = 13,
  ExportPreQualified = 14,
  EditSiteConfiguration = 15,
  RestrictionAdd = 16,
  ScreeningEnrollmentExportLog = 17,
  SyncGroupMember = 18,
  AddCommunicationNote = 19,
  AddStudyNote = 20,
  ExportApplicantAudit = 21,
  AddGroupMember = 22,
  EditGroupMember = 23,
}

export enum Screen {
  Study = 1,
  QuestionLibrary = 2,
  Applicant = 3,
  GroupMember = 4,
  SiteConfiguration = 5,
  Restriction = 6,
  ScreeningEnrollmentExport = 7
}

export enum Role {
  Administrator = 1,
  ProjectManager = 2,
  ClinicalResearchCoordinator = 3,
  Recruiter = 4,
  RecruiterAssociate = 5,
  ClinicalAssociate = 6,
  Visitor = 7
}

export enum ApplicantStatus {

  PreQualified = 1,
  Disqualified = 2,
  Contacted = 3,
  Prescreened = 4,
  Scheduled = 5,
  Processed = 6,
  Cancelled = 7,
  Other = 8,
  Screened = 9,
  Enrolled = 10,
  ScreenFailed = 11,
  CompletedStudy = 12,
  EarlyTermination = 13,
  LosttoFollowUp = 14,
  Incomplete = 15,
}

export enum StatusReason {
  Other = 6,
  EarlyTerminatedOther = 16
}

export enum ReportType {
  ScreeningLog = 'ScreeningLog',
  EnrollmentLog = 'EnrollmentLog',
  SubjectInitials = 'SubjectInitails',
  SubjectFullName = 'SubjectFullName'
}
